var destinationAjaxListForForeign = function (element, searchUrl, minimumInputLength) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option[value]:not([selected])', element);
    var defaultResults = [{id: 0, text: init_select2_trans.popular_cities, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            country_code: $option.data('countrycode'),
            province_name: $option.data('provincename'),
            province_code: $option.data('provincecode'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_the_name_of_the_city,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {

                if(typeof selected_tour_origin_city  !== 'undefined'){
                    return display(selected_tour_origin_city);
                }

                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    province_name: $element.data('provincename'),
                    province_code: $element.data('provincecode'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.ename + (data.province_code ? ' (' + data.province_code + ')' : ''));
        $wrapper1.addClass('select2-result-iata');
        $parent.append($wrapper1);
        if (data.fname) {
            var $wrapper2 = $('<span></span>');
            $wrapper2.text(data.fname);
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('ltr gray-color smaller');
            $parent.append($wrapper2)
        }
        return $parent
    }
};
var destinationAjaxListForDomestic = function (element, searchUrl, minimumInputLength) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option[value]:not([selected])', element);
    var defaultResults = [{id: 0, text: init_select2_trans.popular_cities, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            country_code: $option.data('countrycode'),
            province_name: $option.data('provincename'),
            province_code: $option.data('provincecode'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_the_name_of_the_city,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.fname) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.fname) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    province_name: $element.data('provincename'),
                    province_code: $element.data('provincecode'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname + (data.province_code ? ' (' + data.province_code + ')' : ''));
        $wrapper1.addClass('select2-result-iata');
        $parent.append($wrapper1);
        if (data.ename) {
            var $wrapper2 = $('<span></span>');
            $wrapper2.text(data.ename);
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('ltr gray-color smaller');
            $parent.append($wrapper2)
        }
        return $parent
    }
};
var CountriesAjaxList = function (element, searchUrl, minimumInputLength) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option[value]:not([selected])', element);
    var defaultResults = [{id: 0, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_code: $option.data('countrycode'),
            iata: $option.data('iata'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            value: $option.data('value'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_the_name_of_the_country,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    iata: $element.data('iata'),
                    value: $element.data('value'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        if (element && data.value) {
            element.html(data.value);
            element.data('value', data.value)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname);
        $parent.append($wrapper1);
        var $wrapper2 = $('<span></span>');
        $wrapper2.text((data.iata ? ' (' + data.iata + ')' : ''));
        $parent.append($wrapper2);
        if (data.fname) {
            var $wrapper3 = $('<span></span>');
            $wrapper3.text(data.ename);
            $wrapper3.css('float', 'left');
            $wrapper3.addClass('ltr gray-color smaller');
            $parent.append($wrapper3)
        }
        return $parent
    }
};
var CountriesCitiesAjaxList = function (element, searchUrl, minimumInputLength) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option[value]:not([selected])', element);
    var defaultResults = [{id: 0, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_code: $option.data('countrycode'),
            iata: $option.data('iata'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            value: $option.data('value'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        // language: "fa",
        language: {
            searching: function() {
                return init_select2_trans.Searching; //Searching...
            },
            errorLoading: function () {
                return init_select2_trans.unable_to_load_result; //The results could not be loaded.
            },
            noResults: function () {
                return init_select2_trans.no_results_found; //no ressult found
            },
        },
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_name_of_city_or_country,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    iata: $element.data('iata'),
                    value: $element.data('value'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        if (element && data.country_name) {
            element.data('country', data.country_name)
        }
        if (element && data.ename) {
            element.data('name', data.ename)
        }
        if (element && data.value) {
            element.html(data.value);
            element.data('value', data.value)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname);
        $parent.append($wrapper1);
        var $wrapper2 = $('<span></span>');
        $wrapper2.text((data.iata ? ' (' + data.iata + ')' : ''));
        $parent.append($wrapper2);
        if (data.fname) {
            var $wrapper3 = $('<span></span>');
            $wrapper3.text(data.ename);
            $wrapper3.css('float', 'left');
            $wrapper3.addClass('ltr gray-color smaller');
            $parent.append($wrapper3)
        }
        return $parent
    }
};
var airportAjaxList = function (element, searchUrl, minimumInputLength) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option[value]:not([selected])', element);
    var Sdata = $('option[value][selected]', element);
    var data = [{
        id: Sdata.attr('value'),
        ename: Sdata.data('ename'),
        ename_slug: Sdata.data('enameslug'),
        fname: Sdata.data('fname'),
        country_code: Sdata.data('countrycode'),
        iata: Sdata.data('iata'),
        country_name: Sdata.data('countryname'),
        country_name_slug: Sdata.data('countrynameslug'),
        value: Sdata.data('value'),
    }];
    var defaultResults = [{id: 0, text: init_select2_trans.popular_airports, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_code: $option.data('countrycode'),
            iata: $option.data('iata'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            value: $option.data('value'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        data: data,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_name_of_airport,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    iata: $element.data('iata'),
                    value: $element.data('value'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        if (element && data.value) {
            element.html(data.value);
            element.data('value', data.value)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname);
        $parent.append($wrapper1);
        var $wrapper2 = $('<span></span>');
        $wrapper2.text((data.iata ? ' (' + data.iata + ')' : ''));
        $parent.append($wrapper2);
        if (data.fname) {
            var $wrapper3 = $('<span></span>');
            $wrapper3.text(data.ename);
            $wrapper3.css('float', 'left');
            $wrapper3.addClass('ltr gray-color smaller');
            $parent.append($wrapper3)
        }
        return $parent
    }
};
var airportAjaxListWithDefault = function (element, searchUrl, minimumInputLength, $default, value = null) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option', $default, $default);
    var defaultResults = [{id: 0, text: init_select2_trans.popular_airports, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_code: $option.data('countrycode'),
            iata: $option.data('iata'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            value: $option.data('value'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_name_of_airport,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                if(value == 'source' &&  typeof selected_source_Airport  !== 'undefined'){
                    return display(selected_source_Airport);
                }

                if(value == 'destination' &&  typeof selected_destination_Airport  !== 'undefined'){
                    return display(selected_destination_Airport);
                }

                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    iata: $element.data('iata'),
                    value: $element.data('value'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        if (element && data.value) {
            element.html(data.value);
            element.data('value', data.value)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname);
        $parent.append($wrapper1);
        var $wrapper2 = $('<span></span>');
        $wrapper2.text((data.iata ? ' (' + data.iata + ')' : ''));
        $parent.append($wrapper2);
        if (data.fname) {
            var $wrapper3 = $('<span></span>');
            $wrapper3.text(data.ename);
            $wrapper3.css('float', 'left');
            $wrapper3.addClass('ltr gray-color smaller');
            $parent.append($wrapper3)
        }
        return $parent
    }
};


var airplaneAjaxListWithDefault = function (element, searchUrl, minimumInputLength, $default, value = null) {

    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option', $default, $default);
    var defaultResults = [{id: 0, text: init_select2_trans.popular_airplanes, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            fname: $option.data('fname'),
            value: $option.data('value'),
        })
    });

    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder:init_select2_trans.Enter_name_of_plane,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                if(typeof selected_Airplane  !== 'undefined'){
                    return display(selected_Airplane);
                }
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            } else {
                return display({
                    id: $option.attr('value'),
                    ename: $option.data('ename'),
                    fname: $option.data('fname'),
                    value: $option.data('value'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        if (element && data.value) {
            element.html(data.value);
            element.data('value', data.value)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname);
        $parent.append($wrapper1);
        var $wrapper2 = $('<span></span>');
        $wrapper2.text((data.iata ? ' (' + data.iata + ')' : ''));
        $parent.append($wrapper2);
        if (data.fname) {
            var $wrapper3 = $('<span></span>');
            $wrapper3.text(data.ename);
            $wrapper3.css('float', 'left');
            $wrapper3.addClass('ltr gray-color smaller');
            $parent.append($wrapper3)
        }
        return $parent
    }
};

var airlineAjaxListWithDefault = function (element, searchUrl, minimumInputLength, $default, value = null) {

    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option', $default, $default);
    var defaultResults = [{id: 0, text: init_select2_trans.popular_airlines, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            fname: $option.data('fname'),
            iata: $option.data('iata'),
            icao: $option.data('icao'),
            value: $option.data('value'),
        })

    });

    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_name_of_airline,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                if(typeof selected_Airline  !== 'undefined'){
                    return display(selected_Airline);
                }
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            }
            else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    fname: $element.data('fname'),
                    iata: $element.data('iata'),
                    icao: $element.data('icao'),
                    value: $element.data('value'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.ename) {
            element.data('ename', data.ename)
        }
        if (element && data.fname) {
            element.data('fname', data.fname)
        }
        if (element && data.iata) {
            element.data('iata', data.iata)
        }
        if (element && data.icao) {
            element.data('icao', data.icao)
        }
        if (element && data.value) {
            element.html(data.value);
            element.data('value', data.value)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.fname) {
            $parent.attr('title', data.fname)
        }
        if (data.fname) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.fname.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname);
        $parent.append($wrapper1);
        var $wrapper2 = $('<span></span>');
        $wrapper2.text((data.fname ? ' (' + data.fname + ')' : ''));
        $parent.append($wrapper2);
        if (data.fname) {
            var $wrapper3 = $('<span></span>');
            $wrapper3.text(data.ename);
            $wrapper3.css('float', 'left');
            $wrapper3.addClass('ltr gray-color smaller');
            $parent.append($wrapper3)
        }
        return $parent
    }
};

var destinationAjaxList = function (element, searchUrl, minimumInputLength, $default) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option', $default);
    var Sdata = $('option[value][selected]', $default);
    var data = [{
        id: Sdata.attr('value'),
        ename: Sdata.data('ename'),
        ename_slug: Sdata.data('enameslug'),
        fname: Sdata.data('fname'),
        country_name: Sdata.data('countryname'),
        country_name_slug: Sdata.data('countrynameslug'),
        country_code: Sdata.data('countrycode'),
        province_name: Sdata.data('provincename'),
        province_code: Sdata.data('provincecode'),
        selected: Sdata.prop('selected'),
    }];
    var defaultResults = [{id: 0, text: init_select2_trans.popular_cities, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            country_code: $option.data('countrycode'),
            province_name: $option.data('provincename'),
            province_code: $option.data('provincecode'),
            selected: $option.prop('selected'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        data: data,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_the_name_of_the_city,
        placeholder: init_select2_trans.choose_city,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.fname) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.fname) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    province_name: $element.data('provincename'),
                    province_code: $element.data('provincecode'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname + (data.province_code ? ' (' + data.province_code + ')' : ''));
        $wrapper1.addClass('select2-result-iata');
        $parent.append($wrapper1);
        if (data.ename) {
            var $wrapper2 = $('<span></span>');
            $wrapper2.text(data.ename);
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('ltr gray-color smaller');
            $parent.append($wrapper2)
        }
        return $parent
    }
};
var flatDestinationAjaxList = function (element, searchUrl, minimumInputLength, allCities = true) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option[value]:not([selected])', element);
    var Sdata = $('option[value][selected]', element);
    var data = [{
        id: Sdata.attr('value'),
        type: 'city',
        ename: Sdata.data('ename'),
        ename_slug: Sdata.data('enameslug'),
        fname: Sdata.data('fname'),
        country_name: Sdata.data('countryname'),
        country_name_slug: Sdata.data('countrynameslug'),
        country_code: Sdata.data('countrycode'),
        province_name: Sdata.data('provincename'),
        province_code: Sdata.data('provincecode'),
    }];
    var defaultResults = [{id: 0, text: init_select2_trans.popular_cities, children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            type: 'city',
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_name: $option.data('countryname'),
            country_name_slug: $option.data('countrynameslug'),
            country_code: $option.data('countrycode'),
            province_name: $option.data('provincename'),
            province_code: $option.data('provincecode'),
        })
    });

    if (allCities === true) {
        defaultResults[0].children.unshift({
            id: 'all',
            type: 'city',
            ename: 'all cities',
            ename_slug: 'all_cities',
            fname: 'همه شهرها',
            country_name: 'all',
            country_name_slug: 'all',
            country_code: 'ir',
            province_name: '',
            province_code: '',
        })
    }

    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        data: data,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_the_name_of_the_city_or_the_flat_code,
        placeholder: init_select2_trans.choosing_city_or_flat,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && (data.fname || data.name)) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.fname) {
                return display(data, $element)
            } else {
                if ($element.data('ename') === undefined) {
                    //persian name of default city
                    return data.text.split("-")[1];
                }
                return display({
                    id: $element.attr('value'),
                    type: 'city',
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_name_slug: $element.data('countrynameslug'),
                    country_code: $element.data('countrycode'),
                    province_name: $element.data('provincename'),
                    province_code: $element.data('provincecode'),
                })
            }
        },
    });

    function display(data, element) {
        if (data.type === 'flat') {
            return displayFlat(data, element)
        } else if (data.type === 'city' && (data.country_code === 'IR' || data.country_code === 'ir')) {
            return displayDomestic(data, element)
        } else if (data.type === 'city' && (data.country_code !== 'IR' || data.country_code !== 'ir')) {
            return displayForeign(data, element)
        } else {
            alert('!!!!!!')
        }
    }

    function displayForeign(data, element) {
        if (element && data.type) {
            element.data('type', data.type)
        }
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.ename + (data.province_code ? ' (' + data.province_code + ')' : ''));
        $wrapper1.addClass('select2-result-iata');
        $parent.append($wrapper1);
        if (data.fname) {
            var $wrapper2 = $('<span></span>');
            $wrapper2.text(data.fname);
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('ltr gray-color smaller');
            $parent.append($wrapper2)
        }
        return $parent
    }

    function displayDomestic(data, element) {
        if (element && data.type) {
            element.data('type', data.type)
        }
        if (element && data.country_name_slug) {
            element.data('countrynameslug', data.country_name_slug)
        }
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname + (data.province_code ? ' (' + data.province_code + ')' : ''));
        $wrapper1.addClass('select2-result-iata');
        $parent.append($wrapper1);
        if (data.ename) {
            var $wrapper2 = $('<span></span>');
            $wrapper2.text(data.ename);
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('ltr gray-color smaller');
            $parent.append($wrapper2)
        }
        return $parent
    }

    function displayFlat(data, element) {
        var $parent = $('<div></div>');
        if (element && data.type) {
            element.data('type', data.type)
        }
        if (element && data.href) {
            element.data('href', data.href)
        }
        $parent.addClass('flat_search_result');
        $parent.data('href', data.href);
        $parent.attr('title', data.name);
        var $img = $('<img>');
        $img.attr('src', data.img);
        $img.css('width', '20%');
        $parent.append($img);
        var $name = $('<span></span>');
        $name.text(data.name);
        $name.css('padding', '4px');
        $parent.append($name);
        return $parent
    }
};
var stationAjaxList = function (element, searchUrl, minimumInputLength) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var $defaultResults = $('option[value]:not([selected])', element);
    var Sdata = $('option[value][selected]', element);
    var data = [{
        id: Sdata.attr('value'),
        ename: Sdata.data('ename'),
        ename_slug: Sdata.data('enameslug'),
        fname: Sdata.data('fname'),
        country_name: Sdata.data('countryname'),
        country_code: Sdata.data('countrycode'),
        selected: Sdata.prop('selected'),
    }];
    var defaultResults = [{id: 0, text: 'ایستگاه های محبوب', children: []}];
    $defaultResults.each(function () {
        var $option = $(this);
        defaultResults[0].children.push({
            id: $option.attr('value'),
            ename: $option.data('ename'),
            ename_slug: $option.data('enameslug'),
            fname: $option.data('fname'),
            country_name: $option.data('countryname'),
            country_code: $option.data('countrycode'),
        })
    });
    element.select2({
        minimumInputLength: minimumInputLength,
        dir: "rtl",
        language: "fa",
        width: '100%',
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        defaultResults: defaultResults,
        data: data,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: init_select2_trans.enter_name_of_city_or_station,
        placeholder: init_select2_trans.choose,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            delay: 250,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return data
                }
                return {results: data}
            }
        },
        templateResult: function (data) {
            if (data.id && data.ename) {
                return display(data)
            } else {
                return data.text
            }
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            if (data.id && data.ename) {
                return display(data, $element)
            } else {
                return display({
                    id: $element.attr('value'),
                    ename: $element.data('ename'),
                    ename_slug: $element.data('enameslug'),
                    fname: $element.data('fname'),
                    country_name: $element.data('countryname'),
                    country_code: $element.data('countrycode'),
                })
            }
        },
    });

    function display(data, element) {
        if (element && data.ename_slug) {
            element.data('enameslug', data.ename_slug)
        }
        var $parent = $('<div></div>');
        $parent.css('font-size', 'smaller');
        if (data.country_name) {
            $parent.attr('title', data.country_name)
        }
        if (data.country_code) {
            var $flag = $('<span></span>');
            $flag.addClass('flag flag-' + data.country_code.toLowerCase());
            $parent.append($flag)
        }
        var $wrapper1 = $('<span></span>');
        $wrapper1.text(data.fname);
        $wrapper1.addClass('select2-result-iata');
        $parent.append($wrapper1);
        if (data.fname) {
            var $wrapper2 = $('<span></span>');
            $wrapper2.text(data.ename);
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('ltr gray-color smaller');
            $parent.append($wrapper2)
        }
        return $parent
    }
};
var searchCountry = function (element, searchUrl) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    element.select2({
        placeholder: init_select2_trans.select, minimumInputLength: 3, ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term), countryName: $('#country_search').val()}
            },
            processResults: function (data) {
                return {
                    results: $.map(data, function (obj) {
                        if (obj.cityName && obj.airportName) {
                            return {id: obj.slug, text: obj.cityName}
                        }
                        return {id: obj.slug, text: obj.name}
                    })
                }
            }
        }, escapeMarkup: function (markup) {
            return markup
        }, templateResult: formatRepoCountrySearch, templateSelection: formatRepoSelectionCountrySearch
    })
};
var defaultSelect2 = function (element) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            var $wrapper = $('<span></span>');
            $wrapper.addClass($element[0].className);
            $wrapper.text(data.text);
            return $wrapper
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
};
var airlineSelect2 = function (element, searchUrl, minimumInputLength) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    element.select2({
        placeholder: init_select2_trans.select, minimumInputLength: minimumInputLength,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                console.log($.trim(params.term));
                return {searchText: $.trim(params.term)}
            },
            processResults: function (data) {
                console.log(data);
                return {
                    results: $.map(data, function (obj) {
                        if (obj.id && obj.value) {
                            return {id: obj.id, text: obj.value}
                        }
                        return {id: obj.id, text: obj.value}
                    })
                }
            }
        },
        width: '100%'
    });
};
var flightCitiesList = function (element) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $text = $element[0].text.split('-');
            if ($text[0] == "شهر یا فرودگاه مبدا" || $text[0] == "شهرهای محبوب" || $text[0] == "شهر یا فرودگاه مقصد" || $text[0] == "همه شهر ها") {
                return $text[0]
            }
            if ($text[0] == "Origin" || $text[0] == "Popular cities" || $text[0] == "Destination" || $text[0] == "All cities") {
                return $text[0]
            }
            var $parent = $('<div></div>');
            var $cityEnName = $('<span></span>');
            var $cityFaName = $('<span></span>');
            var $iata = $('<span></span>');
            var $flag = $('<span></span>');
            $cityEnName.addClass('smaller gray-color ltr pull-right');
            $iata.addClass('smaller gray-color ltr');
            $flag.addClass('flag flag-' + $text[0].toLowerCase());
            $cityEnName.text($text[2]);
            $cityFaName.text($text[1]);
            $iata.text($text[3]);
            $parent.append($flag);
            $parent.append($cityFaName);
            $parent.append($iata);
            $parent.append($cityEnName);
            return $parent
        }, templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName[0] == "شهر یا فرودگاه مبدا") {
                $cityName[1] = 'شهر یا فرودگاه مبدا';
                $cityName[2] = ''
            }
            if ($cityName[0] == "شهرهای محبوب") {
                $cityName[1] = init_select2_trans.popular_cities;
                $cityName[2] = ''
            }
            if ($cityName[0] == "شهر یا فرودگاه مقصد") {
                $cityName[1] = 'شهر یا فرودگاه مقصد';
                $cityName[2] = ''
            }
            return '<div class="parent">\n' + '<span class="select2-result-iata" style="float: right">' + $cityName[1] + '</span>\n' + '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;">' + $cityName[2] + '</span>\n' + '</div>'
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
};
var insuranceCarList = function (element, placeholer_text) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $text = $element[0].text.split('-');
            if ($text[0] == placeholer_text) {
                return $text[0]
            }
            var $parent = $('<div></div>');
            var $enCarType = $('<span></span>');
            var $faCarType = $('<span></span>');
            $enCarType.addClass('smaller gray-color ltr pull-right');
            $enCarType.text($text[1]);
            $faCarType.text($text[0]);
            $parent.append($faCarType);
            $parent.append($enCarType);
            return $parent
        }, templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $carType = $($element[0]).text().split('-');
            if ($carType[0] == placeholer_text) {
                $carType[1] = ''
            }
            var _html = '<div class="parent">\n' + '<span class="select2-result-iata" style="float: right">' + $carType[0] + '</span>\n';
            if ($carType.hasOwnProperty(1))
                _html += '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;">' + $carType[1] + '</span>\n';
            _html += '</div>';
            return _html
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
};
var generalLister = function (_selector) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    _selector = _selector || 'select';
    $(_selector).select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $text = $element[0].text;
            return $text
        }, templateSelection: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $text = $($element[0]).text();
            var _html = '<div class="parent">\n' + '<span class="select2-result-iata" style="float: right">' + $text + '</span>\n';
            _html += '</div>';
            return _html
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
}
var insuranceCarModelList = function (element) {
    insuranceCarList(element, "مدل خودرو")
};
var insuranceCarTypeList = function (element) {
    insuranceCarList(element, "نوع خودرو")
};
var countryORCityList = function (element) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName.length < 2)
                return $($element[0]).text();
            var $parent = $('<div></div>');
            var $wrapper1 = $('<span></span>');
            var $wrapper2 = $('<span></span>');
            var $flag = $('<span></span>');
            $parent.addClass('parent');
            $wrapper1.addClass('select2-result-iata');
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('gray-color smaller ltr');
            $flag.addClass('flag flag-' + $cityName[0].toLowerCase());
            $wrapper1.text($cityName[1]);
            $wrapper2.text($cityName[2]);
            $parent.append($flag);
            $parent.append($wrapper1);
            $parent.append($wrapper2);
            return $parent
        }, templateSelection: function (data) {
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName.length < 2)
                return $($element[0]).text();
            return '<div class="parent">\n' + '<span class="select2-result-iata" style="float: right">' + $cityName[1] + '</span>\n' + '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;">' + $cityName[2] + '</span>\n' + '</div>'
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
};
var countryList = function (element) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $countryName = $($element[0]).text().split('-');
            if ($countryName.length < 2)
                return $($element[0]).text();
            var $parent = $('<div></div>');
            var $wrapper1 = $('<span></span>');
            var $wrapper2 = $('<span></span>');
            var $flag = $('<span></span>');
            $parent.addClass('parent');
            $wrapper1.addClass('select2-result-iata');
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('gray-color smaller ltr');
            $flag.addClass('flag flag-' + $countryName[0].toLowerCase());
            $wrapper1.text($countryName[1]);
            $wrapper2.text($countryName[2]);
            $parent.append($flag);
            $parent.append($wrapper1);
            $parent.append($wrapper2);
            return $parent
        }, templateSelection: function (data) {
            var $element = $(data.element);
            $countryName = $($element[0]).text().split('-');
            if ($countryName.length < 2)
                return $($element[0]).text();
            return '<div class="parent">\n' + '<span class="select2-result-iata" style="float: right">' + $countryName[1] + '</span>\n' + '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;">' + $countryName[2] + '</span>\n' + '</div>'
        }, dir: "rtl", placeholder: placeholder, width: '100%', matcher: matchCustom
    })
};
var tourCountryORCityList = function (element) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName.length < 2)
                return $($element[0]).text();
            var $parent = $('<div></div>');
            var $wrapper1 = $('<span></span>');
            var $wrapper2 = $('<span></span>');
            var $flag = $('<span></span>');
            if ($cityName.length == 3) {
                $parent.addClass('parent');
                $flag.addClass('flag flag-' + $cityName[0].toLowerCase());
                $wrapper1.text($cityName[1]);
                $wrapper2.text($cityName[2]);
                $parent.append($flag)
            } else {
                $parent.addClass('child');
                $parent.css('margin-left', '10%');
                $parent.css('margin-right', '10%');
                $parent.css('font-size', 'smaller');
                $wrapper1.text($cityName[0]);
                $wrapper2.text($cityName[1])
            }
            $wrapper1.addClass('select2-result-iata');
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('ltr gray-color smaller');
            $parent.append($wrapper1);
            $parent.append($wrapper2);
            return $parent
        }, templateSelection: function (data) {
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName.length < 2)
                return $($element[0]).text();
            return '<div class="parent">\n' + '<span class="select2-result-iata">' + $cityName[1] + '</span>\n' + '<span class="value" style="float: left">' + $cityName[2] + '</span>\n' + '</div>'
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
};

function formatRepoCountrySearch(repo) {
    if (repo.loading) return repo.text;
    var markup = "<div class='parent'>" + "<span class='select2-result-iata'>" + repo.text + "</span><span style='float: left'>" + repo.id + "</span> </div>";
    return markup
}

function formatRepoCategorySearch(repo) {
    if (repo.loading) return repo.text;
    var markup = "<div class='parent' data-id='" + repo.id + "'>" + "<span class='select2-result-iata'>" + repo.text + "</span><span style='float: left'>" + repo.slug + "</span> </div>";
    return markup
}

function formatRepoSelectionCountrySearch(repo) {
    if (repo.id) {
        return "<div class='parent'>" + "<span class='select2-result-iata'>" + repo.text + "</span><span style='float: left'>" + repo.id + "</span> </div>"
    }
    return repo.text
}

function formatRepoSelectionCategorySearch(repo) {
    if (repo.slug) {
        return "<div class='parent' data-id='" + repo.id + "'>" + "<span class='select2-result-iata'>" + repo.text + "</span><span style='float: left'>" + repo.slug + "</span> </div>"
    }
    return repo.text
}

function matchCustom(params, data) {
    if ($.trim(params.term) === '') {
        return data
    }
    if (typeof data.text === 'undefined') {
        return null
    }
    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) > -1 && !$(data.element).hasClass('most-visit')) {
        var modifiedData = $.extend({}, data, !0);
        return modifiedData
    }
    return null
}

var hotelList = function (element) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName[0] == "همه هتل ها") {
                return $cityName[0]
            }
            var $parent = $('<div></div>');
            var $wrapper1 = $('<span></span>');
            var $wrapper2 = $('<span></span>');
            $parent.addClass('parent');
            $wrapper1.addClass('select2-result-iata');
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('gray-color smaller ltr');
            $wrapper1.text($cityName[0]);
            $wrapper2.text($cityName[1]);
            $parent.append($wrapper1);
            $parent.append($wrapper2);
            return $parent
        }, templateSelection: function (data) {
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName[0] == 'همه هتل ها') {
                $cityName[0] = 'همه هتل ها';
                $cityName[1] = ''
            }
            return '<div class="parent">\n' + '<span class="select2-result-iata" style="float: right">' + $cityName[0] + '</span>\n' + '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;">' + $cityName[1] + '</span>\n' + '</div>'
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
};
var flatList = function (element) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = init_select2_trans.select;
    element.select2({
        escapeMarkup: function (markup) {
            return markup
        }, templateResult: function (data) {
            if (!data.element) {
                return data.text
            }
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName[0] == "همه اقامتگاه ها") {
                return $cityName[0]
            }
            var $parent = $('<div></div>');
            var $wrapper1 = $('<span></span>');
            var $wrapper2 = $('<span></span>');
            $parent.addClass('parent');
            $wrapper1.addClass('select2-result-iata');
            $wrapper2.css('float', 'left');
            $wrapper2.addClass('gray-color smaller ltr');
            $wrapper1.text($cityName[0]);
            $wrapper2.text('');
            $parent.append($wrapper1);
            $parent.append($wrapper2);
            return $parent
        }, templateSelection: function (data) {
            var $element = $(data.element);
            $cityName = $($element[0]).text().split('-');
            if ($cityName[0] == 'همه اقامتگاه ها') {
                $cityName[0] = 'همه اقامتگاه ها';
                $cityName[1] = ''
            }
            return '<div class="parent">\n' + '<span class="select2-result-iata" style="float: right">' + $cityName[0] + '</span>\n' + '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;"></span>\n' + '</div>'
        }, dir: "rtl", placeholder: placeholder, width: null, matcher: matchCustom
    })
};
var userForMessage = function (element, searchUrl) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    element.select2({
        placeholder: init_select2_trans.select,
        minimumInputLength: 3,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                return {
                    results: $.map(data, function (val, key) {
                        return {text: val, id: key}
                    })
                }
            }
        },
        escapeMarkup: function (markup) {
            return markup
        },
        templateResult: formatRepoUserForMessage,
        templateSelection: formatRepoSelectionUserForMessage,
        dir: "rtl",
        width: '100%'
    })
};

function formatRepoUserForMessage(repo) {
    var markup = "<option class='select2-result' value='" + repo.id + "'>" + repo.text + "</option>";
    return markup
}

function formatRepoSelectionUserForMessage(repo) {
    if (repo.id) {
        return "<option class='select2-result' value='" + repo.id + "'>" + repo.text + "</option>"
    }
    return repo.text
}

var CategoryAjaxListForHealthTourism = function (element, searchUrl, minimumInputLength) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    element.select2({
        placeholder: init_select2_trans.select, minimumInputLength: minimumInputLength,
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term)}
            },
            processResults: function (data) {
                return {
                    results: $.map(data, function (obj) {
                        if (obj.id && obj.name && obj.slug) {
                            return {id: obj.slug, slug: obj.slug, text: obj.name}
                        }
                        return {id: obj.slug, slug: obj.id, text: obj.name}
                    })
                }
            }
        }, escapeMarkup: function (markup) {
            return markup
        }, templateResult: formatRepoCategorySearch, templateSelection: formatRepoSelectionCategorySearch
    })
};

var userForMLM = function (element, domainOwnerId, domainOwnerName, searchUrl) {
    // $.fn.select2.defaults.set("theme", "bootstrap");
    var defaultResults = [{'in' : domainOwnerName+' (ورود به درخت) ', 'exit':'خروج از درخت'}];
    element.select2({
        dataAdapter: $.fn.select2.amd.require('select2/data/extended-ajax'),
        placeholder: init_select2_trans.select,
        minimumInputLength: 3,
        defaultResults: defaultResults,
        selectionTitleAttribute: !1,
        searchInputPlaceholder: 'نام کاربر را وارد نمایید ...',
        ajax: {
            type: 'POST',
            url: searchUrl,
            dataType: 'json',
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            data: function (params) {
                return {searchText: $.trim(params.term),}
            },
            processResults: function (data) {
                if (data.results) {
                    return {
                        results: $.map(data.results[0], function (val, key) {
                            return {text: val, id: key}
                        })
                    }
                }
                return {
                    results: $.map(data, function (val, key) {
                        return {text: val, id: key}
                    })
                }
            }
        },
        escapeMarkup: function (markup) {
            return markup
        },
        templateResult: formatRepoUserForMLM,
        templateSelection: formatRepoSelectionUserForMLM,
        dir: "rtl",
        width: '100%',
    })
};

function formatRepoUserForMLM(repo) {
    var markup = "<option class='select2-result' value='" + repo.id + "'>" + repo.text + "</option>";
    return markup
}

function formatRepoSelectionUserForMLM(repo) {
    if (repo.id) {
        return "<option class='select2-result' value='" + repo.id + "'>" + repo.text + "</option>"
    }
    return repo.text
}